// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/signal_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { SignalService } from "./signal_service_pb";

/**
 * @generated from rpc inventory.v1.SignalService.ListSignals
 */
export const listSignals = SignalService.method.listSignals;

/**
 * Support-only. Includes hidden + false-positive rows. Hidden titles arrive
 * with a "* " prefix.
 *
 * @generated from rpc inventory.v1.SignalService.ListSignalsIncludingInvisible
 */
export const listSignalsIncludingInvisible = SignalService.method.listSignalsIncludingInvisible;

/**
 * @generated from rpc inventory.v1.SignalService.GetSignal
 */
export const getSignal = SignalService.method.getSignal;

/**
 * Returns the alert-lifecycle timeline for the alert promoted from this
 * signal: status transitions, severity changes, comments. Both the alert
 * detail view and the signal detail view call this — same backing data.
 *
 * @generated from rpc inventory.v1.SignalService.GetSignalTimeline
 */
export const getSignalTimeline = SignalService.method.getSignalTimeline;

/**
 * Toggle the false-positive flag on a signal. False-positive signals don't
 * surface as alerts (alert_visible flips to false). Used from both the
 * signal feed view and the alert detail view.
 *
 * @generated from rpc inventory.v1.SignalService.MarkSignalFalsePositive
 */
export const markSignalFalsePositive = SignalService.method.markSignalFalsePositive;

/**
 * Add a comment to the signal's comment thread. The thread is shared with
 * the signal's promoted-alert view (one thread per signal).
 *
 * @generated from rpc inventory.v1.SignalService.AddSignalComment
 */
export const addSignalComment = SignalService.method.addSignalComment;

/**
 * Support-only: set org signal visibility (hide/unhide).
 *
 * @generated from rpc inventory.v1.SignalService.SetOrgSignalVisibility
 */
export const setOrgSignalVisibility = SignalService.method.setOrgSignalVisibility;

/**
 * Support-only: set or clear a signal's false positive, both directions.
 *
 * @generated from rpc inventory.v1.SignalService.SetOrgSignalFalsePositive
 */
export const setOrgSignalFalsePositive = SignalService.method.setOrgSignalFalsePositive;

/**
 * Support-only: every signal of the org, hidden and false positives included.
 *
 * @generated from rpc inventory.v1.SignalService.ListSignalsBackoffice
 */
export const listSignalsBackoffice = SignalService.method.listSignalsBackoffice;

/**
 * Support-only: one signal with its detail and full timeline, support rows included.
 *
 * @generated from rpc inventory.v1.SignalService.GetSignalBackoffice
 */
export const getSignalBackoffice = SignalService.method.getSignalBackoffice;

/**
 * Support-only: create an org-scoped signal with optional document quotes.
 * The "Org" prefix here is intentional and disambiguates from CreateSignal
 * (which creates a company-level signal); both stay support-only.
 *
 * @generated from rpc inventory.v1.SignalService.CreateOrgSignal
 */
export const createOrgSignal = SignalService.method.createOrgSignal;

/**
 * Support-only: create a company-scoped signal (EU-hosted only).
 *
 * @generated from rpc inventory.v1.SignalService.CreateSignal
 */
export const createSignal = SignalService.method.createSignal;
